import React from 'react';
import $events from "../../../blocs/EventBloc";
import $ from "jquery";

export default class TutorialOverlaySpotlights extends React.Component {
    constructor( props ) {
        super(props);
    }

    componentDidMount() {
        $events.$on('swipescreen/detectSpot', ( $spot ) => {
            $(`#spotlight_${$spot.index}`).css({
                opacity:   1,
                left:      $spot.offset().left,
                top:       $spot.offset().top,
                transform: 'translate(-8px, -8px) scale(1)'
            });
        });

        $events.$on('swipescreen/lostSpot', ( $spot ) => {
            $(`#spotlight_${$spot.index}`).css({
                opacity:   0,
                transform: 'translate(-8px, -8px) scale(0.8)'
            });
        });
    }

    componentWillUnmount() {
        $events.$off('swipescreen/detectSpot');
        $events.$off('swipescreen/lostSpot');
    }

    render() {
        console.log("build");
        return (
            <div className="tutorial-area__spotlight-container">
                <div className={`tutorial-spot-spotlights  ${( this.props.tutorialState.swipeLearned === true ) ? 'is--visible' : ''}`}
                     ref={this.spotlightContainer}>
                    {this.props.roomState.room.spots.map(( spot, i ) => <div className="spotlight" id={`spotlight_${i}`}></div>)}
                </div>
            </div>
        );
    }

}
